import range from 'lodash/range';

import {TProps} from '../InputPicker';

type TTimePickerProps = Omit<TProps, 'renderHead' | 'scrollTo'>;

const OPTION_HEIGHT = 36;

// c 8:30 до 8:00
const times = range(8.5 * 60, (24 + 8.5) * 60, 30).map((minutesCount: number) => {
  let hours = Math.floor(minutesCount / 60);

  if (hours >= 24) {
    hours %= 24;
  }
  const hh = hours.toString().length < 2 ? `0${hours}` : hours;
  const minutes = (minutesCount % 60).toString();
  const mm = minutes.length < 2 ? `0${minutes}` : minutes;

  return `${hh}:${mm}`;
});

const DEFAULT_WIDTH = '104px';

export {DEFAULT_WIDTH, times, OPTION_HEIGHT};
export type {TTimePickerProps};
